const galleryWrapper = document.querySelector('.grid__item.product__media-wrapper');
const mediaGallery = galleryWrapper.querySelector('media-gallery');

if (mediaGallery) {
  function debounce(func, wait = 20) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);
      }, wait);
    };
  }

  const mediaQueryStandard = window.matchMedia('(min-width: 1100px) and (max-height: 1143px)');
  const mediaQueryLarge = window.matchMedia('(min-width: 1440px) and (min-height: 1144px)');
  const mediaGrid = mediaGallery.querySelector('.product__media-list.contains-media.grid');
  const mainSlider = galleryWrapper.querySelector('slider-component:not(.thumbnail-slider)');
  const mainImage = galleryWrapper.querySelector('.product__media-list.contains-media.slider--desktop');
  const thumbSlider = galleryWrapper.querySelector('.thumbnail-slider');
  const mainSliderBttns = galleryWrapper.querySelector('.slider-buttons-main');
  const thumbnailSliderEl = galleryWrapper.querySelector('slider-component.thumbnail-slider');

  function updateGalleryLayout() {
    const isTargetScreenSize = mediaQueryLarge.matches || mediaQueryStandard.matches;

    if (!isTargetScreenSize) {
      mediaGallery.style.height = '';
      galleryWrapper.style.flexBasis = '';
      galleryWrapper.style.minWidth = '';
      mainSliderBttns.style.right = '';
      return;
    }

    // Height Logic
    const rect = mediaGallery.getBoundingClientRect();
    const remainingHeight = window.innerHeight - (rect.top + window.scrollY);
    mediaGallery.style.height = `${remainingHeight}px`;

    // Width Logic
    if (mainImage && thumbSlider) {
        const galleryHeight = mediaGallery.clientHeight;
        const mainImageWidth = mainImage.clientWidth;
        const maxThumbSliderWidth = (galleryHeight / 1.5) * (3 / 4);
        galleryWrapper.style.flexBasis = `${maxThumbSliderWidth + mainImageWidth}px`;
    } else if (mainImage)  {
      galleryWrapper.style.flexBasis = `${mediaGrid.clientWidth}px`;
      galleryWrapper.style.minWidth = `${mediaGrid.clientWidth}px`;
    }

    // Thumbnail Slider Logic
    if (thumbnailSliderEl && mainSlider) {
        const galleryWidth = mediaGallery.clientWidth;
        const mainSliderImg = mainSlider.querySelector('.product__media-list');
        const mainSliderWidth = mainSliderImg.clientWidth;
        const thumbnailsWidth = galleryWidth - mainSliderWidth;
        const mainSliderBttns = galleryWrapper.querySelector('.slider-buttons-main');

        if (thumbnailsWidth < 150) {
            thumbnailSliderEl.style.position = 'absolute';
            const rightValue = mainSlider.clientWidth - mainSliderImg.clientWidth + 7;
            mainSliderBttns.style.right = `${rightValue}px`;
        } else {
            thumbnailSliderEl.style.position = '';
            mainSliderBttns.style.right = '';
        }
    }
  }

  // Debounced version attached to one listener
  const debouncedUpdate = debounce(updateGalleryLayout, 150);
  window.addEventListener('resize', debouncedUpdate);

  // Run it Once on Page Load
  updateGalleryLayout();

  function handleCylindoArrows() {
    const cylindoViewer = document.querySelector('cylindo-viewer');
    const shadowRoot = cylindoViewer?.shadowRoot;
    const arrows = shadowRoot?.querySelectorAll('[part*=navigation]');
    if (arrows && arrows.length) arrows.forEach((arrow) => arrow.remove());
    else setTimeout(handleCylindoArrows, 250);
  }
  setTimeout(handleCylindoArrows, 500);
}